import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"

import '../styles/styles.css'

const ResumePage = () => (
  <Layout>
    <SEO title="Resume" />
        <main>
            <header>
                <div className="row">
                    <div className="columns small-12">
                        <div className="email">
                            <h2 className="sectionTitle">Contact</h2>
                            <a href="https://mattwojas.com/resume/matt.wojas@gmail.com">matt.wojas@gmail.com</a>
                            <br/><br/>
                        </div>
                    </div>
                </div>
            </header>
		
		<section className="education spacedVertUp">
			<div className="row">
				<div className="columns small-12">
					<h2 className="sectionTitle">Education</h2>
				</div>
			</div>
			<div className="row">
				<div className="educationItem Item columns small-12  ng-scope" ng-repeat="education in educations">
					<h3 className="showContent ">Humber College</h3>
					<div className="hiddenContent">
						<h4 className="">Post Graduate Certificate in Web Development</h4>						
						<div className="Summary ">Studied Web, .Net, PHP, Wordpress, XHTML, CSS, C#, Javascript, AJAX, SQL, OOP, Web Accessibility, Design.</div>
						<div className="Year ">Graduated August 2010</div>
						<ul>
							<li ng-repeat="event in education.keyEvents" className=" ng-scope">Created Content Management Systems from scratch in PHP and .NET(C#).</li><li ng-repeat="event in education.keyEvents" className=" ng-scope">Studied modern web standards and best practices.</li>
						</ul>	
					</div>
					
						
				</div><div className="educationItem Item columns small-12  ng-scope" ng-repeat="education in educations">
					<h3 className="showContent ">University of Toronto</h3>
					<div className="hiddenContent">
						<h4 className="">Honours Bachelor of Arts</h4>						
						<div className="Summary ">English Maj./History/Writing, Rhetoric &amp; Critical Analysis </div>
						<div className="Year ">Graduated June 2007</div>
						<ul>
							<li ng-repeat="event in education.keyEvents" className=" ng-scope">Honed research and communication skills.</li><li ng-repeat="event in education.keyEvents" className=" ng-scope">Improved ability to process and analyze large amounts of information.</li>
						</ul>	
					</div>
					
						
				</div>					
			</div>
		</section>
		<section className="experience spacedVertUp">
			<div className="row ">
				<div className="columns small-12">
					<h2 className="sectionTitle">Professional Experience</h2>
				</div>
			</div>
			<div className="row">			
				<div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">Architech</h3>
					<div className="hiddenContent">
						<h4 className="">Senior Developer</h4>
						<div className="Year ">August 15, 2017 - Present</div>
						<p className="">Software Consultant for various projects</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">Worked in Python and React to Build new features and fix bugs on the Wave Accounting web application</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Using Git version control in a fast-paced, agile engineering environment</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Added automation testing framework to Jenkins build pipeline</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Unit and integration testing utilities (Jasmine, Enzyme, Selenium, Mocha) and methodologies</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Optimized mobiile performance of legacy website</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Lead a team in modernizing a legacy web application to a modern tech stack</li>
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">A.K.A. New Media</h3>
					<div className="hiddenContent">
						<h4 className="">Front End Web Developer</h4>
						<div className="Year ">December 3, 2010 - August 3, 2017</div>
						<p className="">Built and maintained web properties and online presences; performed other IT duties.</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">Studied
 and built professional, responsive, standards compliant, multi-lingual 
web sites and custom applications. (*see below for examples)</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Worked primarily with XHTML, CSS.*, SASS, LESS, Javascript, Jquery, AJAX, C#, SQL, Angular (v.1.x).</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Used
 Gulp, Node, Sublime Text, Git CLI, Cordova,  Sourcetree, IIS, 
Foundation, Bootstrap, Kentico (v.5-10), Photoshop, Google Maps API.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Ensured sites met standards(W3C), accessibility (AODA level A + AA), and SEO best practices.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Tested and configured sites for cross-browser and backwards compatibility.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Implemented various API integrations (Custom, Social Media, Spectrix, Google Maps, Miscrosoft Exchange API).</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Collaborated and communicated with design and account teams throughout all projects.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Interviewed, screened, and trained new hires.  Lead development of new projects.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Provided support on UX and UI for akaraisin (Software as a Service solution for fundraising).</li>
						</ul>
						<strong className="sampleSitesHeader" ng-show="experience.sampleSites">*Recently built examples:</strong>
						<div className="clear"></div>
						<div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Hopeair</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://hopeair.ca/">	
										<span className="">hopeair.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Canada Media Fund</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://cmf-fmc.ca/">	
										<span className="">cmf-fmc.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Frontier College</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://frontiercollege.ca/">	
										<span className="">frontiercollege.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Women's College Hospital Foundation</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://wchf.ca/">	
										<span className="">wchf.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">DAS</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://das.ca/">	
										<span className="">das.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Luminato Event Scheduler</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://luminatofestival.ca/">	
										<span className="">luminatofestival.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Hospitals of Regina Foundation</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://hrf.sk.ca/">	
										<span className="">hrf.sk.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Joseph Brant Hospital Foundation</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://jbhfoundation.ca/">	
										<span className="">jbhfoundation.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Maple Leaf Sport's and Entertainment</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://mlsefoundation.org/">	
										<span className="">mlsefoundation.org</span>
									</a>
								</div><div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://mlselaunchpad.org/">	
										<span className="">mlselaunchpad.org</span>
									</a>
								</div><div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://mlseteamupchallenge.com/">	
										<span className="">mlseteamupchallenge.com</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Chicken Farmers of Ontario</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://artisanalchicken.ca/">	
										<span className="">artisanalchicken.ca</span>
									</a>
								</div><div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://ontariochicken.ca/">	
										<span className="">ontariochicken.ca</span>
									</a>
								</div><div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://specialtybreeds.ca/">	
										<span className="">specialtybreeds.ca</span>
									</a>
								</div>
							</div>
						</div><div ng-repeat="site in experience.sampleSites" className="sites columns smallCol small-12 medium-4 large-3 end ng-scope">
							<div className="site">
								<div className="title ">Schneider Electric Motor Data Calculator</div>
								<div ng-repeat="url in site.urls" className="ng-scope">
									<a target="_blank" rel="noreferrer" href="http://play.google.com/store/apps/details?id=com.schneiderelectric.motordatacalculatorus">	
										<span className="">play.google.com/store/apps/details?id=com.schneiderelectric.motordatacalculatorus</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">PopHire</h3>
					<div className="hiddenContent">
						<h4 className="">QA Analyst</h4>
						<div className="Year ">November 1, 2010 - April 1, 2011</div>
						<p className="">Analyze a start-up application for bugs, quality, and UX.</p>
						<ul>
							
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">Sunrank</h3>
					<div className="hiddenContent">
						<h4 className="">Developer Intern</h4>
						<div className="Year ">July 1, 2010 - October 1, 2010</div>
						<p className="">Internship at Extreme Labs start-up incubator.</p>
						<ul>
							
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">Victory Verbatim </h3>
					<div className="hiddenContent">
						<h4 className="">Court Reporter </h4>
						<div className="Year ">October 3, 2006 - February 16, 2008</div>
						<p className="">Coordinated and assisted Counsel with the audio recording and procedures of legal examinations.</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">Gained exposure to Ontario Legislation in a legal environment.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Attended Arbitration Hearings, depositions, and examinations.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Edited and proofread legal transcripts for quality and accuracy.</li>
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">wagi.ca </h3>
					<div className="hiddenContent">
						<h4 className="">Research Assistant </h4>
						<div className="Year ">February 3, 2006 - June 16, 2009</div>
						<p className="">In a part time position I assisted a senior real estate appraiser with report preparation and researching/analyzing data.</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">Utilized a variety of real estate data base systems for searching, compiling and analyzing data. </li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Inputting graphics. </li>
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div><div className="experienceItem Item columns small-12 ng-scope" >
					<h3 className="showContent ">Centre for Addiction and Mental Health</h3>
					<div className="hiddenContent">
						<h4 className="">Volunteer Music Therapist</h4>
						<div className="Year ">June 1, 2005 - June 1, 2006</div>
						<p className="">During a one year volunteer position I initiated and spearheaded a music therapy program for patients.</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">Organized interactive activities.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Communicated, explained, and taught musical concepts to patients.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Created a friendly and caring atmosphere for patients, enabling them to feel comfortable taking part in the program.</li>
						</ul>
						
						<div className="clear"></div>
						
					</div>
				</div>			
			</div>
		</section>
		<section className="personal spacedVertUp">
			<div className="row">
				<div className="columns small-12">
					<h2 className="sectionTitle">Personal Experience</h2>
				</div>
			</div>
			<div className="row">			
				<div className="experienceItem Item columns small-12 ng-scope" ng-repeat="experience in experiencesPersonal | orderBy : '-experience.startDate'">
					<h3 className="showContent ">Developer</h3>
					<div className="hiddenContent">
						<h4 className="">Hobby/Freelance Developer</h4>
						<div className="Year ">December 3, 2010 - Present</div>
						<p className="">Personal and freelance projects.</p>
						<ul>
							<li ng-repeat="event in experience.keyEvents" className=" ng-scope">An environmental data monitoring application in Python on a Raspberry Pie</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">A data logging application, which logged data to a MySql database displayed to a php backend/js frontend.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">An application in angular and MySql to manage and store lunch places.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Configured cloud linux/apache web server for personal site and projects.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Worked on various freelance projects in static HTML, Wordpress, and Kentico.</li><li ng-repeat="event in experience.keyEvents" className=" ng-scope">Performed needs assessment and communication throughout project with clients.</li>
						</ul>
					</div>
				</div>			
			</div>
		</section>
	</main>
    <Link to="/">Go back to the homepage</Link>
  </Layout>
)

export default ResumePage
